import ListItem from '../utils/ListItem';

function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '').trim();
}

function MissionsListItem(props) {
  return (
    <ListItem
      to={props.link}
      primary={props.name}
      secondary={stripHtml(props.descr)}
      meta={props.date}
    />
  );
}

export default MissionsListItem;
